import { selectEnv } from 'common-nextjs';

export default function absoluteUrl(path?: string) {
  return selectEnv(
    `https://sidelineswap.com${path || '/'}`,
    `https://staging.sidelineswap.com${path || '/'}`,
    `http://local.staging.sidelineswap.com:3000${path || '/'}`,
  );
}
